import { raise } from "xstate"
import * as E from "fp-ts/Either"
import { PricesResponseV2 } from "@ssc-booking/api-contracts"
import {
    raiseGuestsChanged,
    raiseStandardSuiteCategorySelected,
    raiseSuiteNumberSelected,
} from "../ecommerce-machine/actions/flow-actions"
import { raiseFareCardsLoaded, raiseFareSelected } from "../ecommerce-machine/actions/fare-card-actions"
import { FlowVersion } from "./flow-version"

export const raiseEventsForCheckoutRestoredV4: FlowVersion["stateMachine"]["flow"]["raiseEventsForCheckoutRestored"] = (
    checkout,
    fareCard,
) => {
    const validatedPrice = checkout.validatedPrice

    return [
        ...raiseGuestsChanged(validatedPrice.occupancy),
        ...raiseFareCardsLoaded([fareCard]),
        raise({
            type: "FARE_SUITE_PRICES_LOADED",
            index: fareCard.index,
            response: PricesResponseV2.build({ prices: [E.right(validatedPrice)] }),
        }),
        ...raiseStandardSuiteCategorySelected(validatedPrice.suiteCategory),
        ...raiseFareSelected(fareCard),
        ...(checkout.type === "started" ? raiseSuiteNumberSelected(checkout.suiteNumber) : []),
        raise({ type: "CHECKOUT_RESTORED" }),
    ]
}
